import { useEffect, useState, useRef } from "react";
import Sidebar from "./Sidebar/Sidebar";
import { Outlet } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";

const Dashboard = ({ Ip }) => {
  const [hasAccess, setHasAccess] = useState(false);
  const inactivityTimeout = useRef(null);
  const logout = async () => {
    try {
      const formData = new FormData();
      formData.append("Action", "logout");
      await axios.post(`${Ip}/Dashboard/logout.php`, formData, {
        withCredentials: true,
      });
    } catch (err) {
      console.error("Logout failed:", err);
    } finally {
      window.location.href = "/admin"; // redirect in all cases
    }
  };
  const resetInactivityTimer = () => {
    if (inactivityTimeout.current) clearTimeout(inactivityTimeout.current);
    inactivityTimeout.current = setTimeout(
      () => {
        Swal.fire({
          icon: "warning",
          title: "Logged out",
          text: "You were inactive for 10 minutes.",
          confirmButtonText: "OK",
        }).then(() => logout());
      },
      10 * 60 * 1000,
    );
  };
  useEffect(() => {
    const checkSession = async () => {
      try {
        const response = await axios.get(`${Ip}/Dashboard/session_check.php`, {
          withCredentials: true,
        });

        // if (!response.data.loggedIn || response.data.accessLvl !== 1) {
        if (!response.data.loggedIn) {
          Swal.fire({
            icon: "warning",
            title: "Access Denied",
            text: "You need to log in first or have proper access!",
            confirmButtonText: "OK",
          }).then(() => {
            window.location.href = "/";
          });

          setHasAccess(false);
        } else {
          // Store the whole object as JSON
          localStorage.setItem("admin_info", JSON.stringify(response.data));
          setHasAccess(true);
        }
      } catch (err) {
        console.error(err);
        Swal.fire({
          icon: "error",
          title: "Server Error",
          text: "Could not verify access",
        });
        setHasAccess(false);
      }
    };

    checkSession();
    const activityEvents = [
      "mousemove",
      "mousedown",
      "keydown",
      "scroll",
      "touchstart",
    ];
    activityEvents.forEach((event) =>
      window.addEventListener(event, resetInactivityTimer),
    );
    resetInactivityTimer();
    return () => {
      if (inactivityTimeout.current) clearTimeout(inactivityTimeout.current);
      activityEvents.forEach((event) =>
        window.removeEventListener(event, resetInactivityTimer),
      );
    };
  }, [Ip]);

  if (!hasAccess) return null;

  return (
    <div className="flex min-h-screen">
      {/* Sidebar stays fixed width */}
      <Sidebar Ip={Ip} />

      {/* Main takes remaining space */}
      <main
        className="ml-64 flex-1 p-6 
                   bg-gradient-to-b from-light-background to-light-surface 
                   dark:from-dark-background dark:to-dark-surface 
                   text-light-text dark:text-dark-text 
                   min-h-screen transition-colors duration-200 
                   overflow-x-auto"
      >
        <Outlet />
      </main>
    </div>
  );
};

export default Dashboard;
